import React, { useState, useEffect } from 'react';

const DeviceBlocker = ({ children, loading = false, onDeviceCheckComplete }) => {
  const [deviceInfo, setDeviceInfo] = useState({
    isSmartphone: false,
    isTablet: false,
    isDesktop: false,
    screenWidth: 0,
    screenHeight: 0
  });
  const [forceOpen, setForceOpen] = useState(false);
  const [deviceCheckCompleted, setDeviceCheckCompleted] = useState(false);

  useEffect(() => {
    const detectDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const userAgent = navigator.userAgent;
      
      // Erweiterte Smartphone-Erkennung
      const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isTabletUserAgent = /iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(userAgent);
      
      // Screen-basierte Erkennung (wichtiger als User Agent)
      const isSmallScreen = width < 768; // Smartphones haben typisch < 768px Breite
      const isMediumScreen = width >= 768 && width < 1024; // Tablets
      const isLargeScreen = width >= 1024; // Desktop
      
      // Spezielle iPad Mini Behandlung (768px+ Breite)
      const isiPad = /iPad/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      
      // Kombinierte Logik
      let isSmartphone = false;
      let isTablet = false;
      let isDesktop = false;
      
      if (isLargeScreen) {
        isDesktop = true;
      } else if (isMediumScreen || isiPad) {
        isTablet = true;
      } else if (isSmallScreen && isMobile) {
        isSmartphone = true;
      } else if (isSmallScreen && !isMobile) {
        // Kleine Desktop-Fenster sind erlaubt
        isDesktop = true;
      }
      
      console.log('🔍 Device Detection:', {
        width,
        height,
        userAgent: userAgent.substring(0, 100),
        isMobile,
        isTabletUserAgent,
        isiPad,
        classification: { isSmartphone, isTablet, isDesktop }
      });
      
      setDeviceInfo({
        isSmartphone,
        isTablet,
        isDesktop,
        screenWidth: width,
        screenHeight: height
      });
      
      // Für Desktop/Tablet sofort abschließen
      if (!deviceCheckCompleted && (!isSmartphone)) {
        console.log('✅ Desktop/Tablet erkannt - Device Check abgeschlossen');
        setDeviceCheckCompleted(true);
        if (onDeviceCheckComplete) {
          onDeviceCheckComplete();
        }
      }
    };

    detectDevice();
    
    window.addEventListener('resize', detectDevice);
    return () => window.removeEventListener('resize', detectDevice);
  }, [deviceCheckCompleted, onDeviceCheckComplete]);

  // Handle force open für Smartphones
  const handleForceOpen = () => {
    console.log('🔓 Trotzdem öffnen geklickt');
    console.log('🔄 [DEBUG] onDeviceCheckComplete function:', onDeviceCheckComplete);
    setForceOpen(true);
    setDeviceCheckCompleted(true);
    if (onDeviceCheckComplete) {
      console.log('🔄 [DEBUG] Callback wird aufgerufen...');
      onDeviceCheckComplete();
      console.log('🔄 [DEBUG] Callback aufgerufen!');
    } else {
      console.log('❌ [DEBUG] onDeviceCheckComplete ist null/undefined!');
    }
  };

  // Wenn noch geladen wird, zeige Loading an
  if (loading && !forceOpen) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f0f8e8 0%, #e8f4f8 50%, #f8f0e8 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Comic Neue', 'Comic Sans MS', 'Comic Sans', cursive, sans-serif"
      }}>
        <div style={{
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          padding: '40px',
          textAlign: 'center',
          maxWidth: '500px',
          width: '90%'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '20px'
          }}>🔐</div>
          <h2 style={{
            fontSize: '28px',
            color: '#8db9a3',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            marginBottom: '15px'
          }}>Geräteprüfung...</h2>
          <p style={{
            fontSize: '16px',
            color: '#666',
            margin: '0'
          }}>Bildschirm wird analysiert...</p>
        </div>
      </div>
    );
  }

  // Smartphone-Blockierung anzeigen (aber nur wenn nicht loading und nicht force opened)
  if (deviceInfo.isSmartphone && !forceOpen) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f0f8e8 0%, #e8f4f8 50%, #f8f0e8 100%)',
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Comic Neue', 'Comic Sans MS', 'Comic Sans', cursive, sans-serif"
      }}>
        <div style={{
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          overflow: 'hidden',
          maxWidth: '600px',
          width: '100%',
          position: 'relative'
        }}>
          {/* Header like lr.php */}
          <div style={{
            background: 'linear-gradient(135deg, #8db9a3 0%, #a3b9d3 100%)',
            padding: '25px',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '-50%',
              left: '-50%',
              width: '200%',
              height: '200%',
              background: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1.5" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="70" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="70" cy="20" r="1.2" fill="rgba(255,255,255,0.1)"/><circle cx="30" cy="50" r="0.8" fill="rgba(255,255,255,0.1)"/></svg>') repeat`,
              animation: 'sparkle 20s linear infinite',
              pointerEvents: 'none'
            }}></div>
            <h2 style={{
              fontSize: '28px',
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              marginBottom: '10px',
              position: 'relative',
              zIndex: 2
            }}>📱 Smartphone erkannt</h2>
            <p style={{
              fontSize: '16px',
              color: 'white',
              opacity: 0.9,
              margin: 0,
              position: 'relative',
              zIndex: 2
            }}>Diese Anwendung ist für größere Bildschirme optimiert</p>
          </div>

          {/* Content */}
          <div style={{
            padding: '30px',
            background: 'linear-gradient(to right, transparent 0%, transparent 49%, #f0f0f0 49%, #f0f0f0 51%, transparent 51%)',
            position: 'relative'
          }}>
            {/* Lined paper effect */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: 'repeating-linear-gradient(transparent, transparent 24px, #e8f4f8 24px, #e8f4f8 26px)',
              opacity: 0.5,
              pointerEvents: 'none'
            }}></div>
            
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{
                textAlign: 'center',
                marginBottom: '25px'
              }}>
                <div style={{ fontSize: '64px', marginBottom: '15px' }}>📱❌</div>
                <p style={{
                  fontSize: '16px',
                  color: '#666',
                  lineHeight: '1.5',
                  marginBottom: '0'
                }}>
                  Bitte verwenden Sie einen Computer oder Tablet für die beste Erfahrung.
                </p>
              </div>

              <div style={{
                background: 'linear-gradient(135deg, #c4d8c4 0%, #d4c8b4 100%)',
                color: 'white',
                padding: '15px',
                borderRadius: '15px',
                marginBottom: '25px',
                textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
              }}>
                <p style={{
                  fontSize: '14px',
                  margin: '0',
                  lineHeight: '1.4'
                }}>
                  <strong>💡 Empfehlung:</strong><br/>
                  Öffnen Sie die Anwendung auf einem Desktop-Computer oder Tablet
                </p>
              </div>

              <button
                onClick={handleForceOpen}
                style={{
                  background: 'linear-gradient(90deg, #8db9a3 0%, #a3b9d3 100%)',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                  color: 'white',
                  padding: '15px 30px',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease',
                  backdropFilter: 'blur(10px)',
                  width: '100%',
                  boxShadow: '0 4px 15px rgba(141, 185, 163, 0.3)',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(141, 185, 163, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(141, 185, 163, 0.3)';
                }}
              >
                Trotzdem öffnen
              </button>

              <p style={{
                textAlign: 'center',
                color: '#999',
                fontSize: '12px',
                marginTop: '15px',
                marginBottom: '0'
              }}>
                Bildschirmgröße: {deviceInfo.screenWidth} × {deviceInfo.screenHeight}px
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Normale Anzeige für Desktop/Tablet oder wenn Force-Open aktiviert
  return <>{children}</>;
};

export default DeviceBlocker;